import React from "react";
import PageHeader from "../components/PageHeader";

export default function BSCPCRRules() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    
    { label: "Bihar Commission for Protection of Child Rights Rules", active: true },
  ];

  const rulesDocuments = [
    {
      title: "Bihar-Commission-for-Protection-of-Child-Rights-Rules-2012",
      link: "/assests/img/bscpcrRuleandActs/chield-right-rule.pdf",
    },
    {
      title: "Bihar-Commission-for-Protection-of-Child-Rights-(Amendment)-Rules-2010",
      link: "/assests/img/bscpcrRuleandActs/amendment-rule.pdf",
    }
  ];

  return (
    <>
      {/* Page Header */}
      <PageHeader
        title=" Bihar Commission for Protection of Child Rights Rules"
        breadcrumbs={breadcrumbs}
      />

      {/* BSCPCR Rules Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-4">
             Rules
          </h2>

          <div className="row g-4 justify-content-center">
            {rulesDocuments.map((doc, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="h-100 bg-white p-4 rounded-4 shadow-sm border-start border-4 border-primary text-center">
                  <h6 className="fw-bold text-primary mb-4">
                    {doc.title}
                  </h6>

                  <a
                   target="_blank"
                    href={doc.link}
                    className="btn btn-sm btn-primary rounded-pill w-100"
                  >
                    View / Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
